/**
 * Leave Preview as customer from outside it, and wait until the design is
 * back. Opening a scene file replaces the whole look — doing that under a
 * live preview would leave the shopper's choices in the designer's history
 * and then rewind them over the scene just opened.
 *
 * `CustomerPreview` registers its own Exit here while it is on; with no
 * preview open, leaving is a no-op.
 */
let exit: (() => Promise<void>) | null = null;

/** Register the live preview's Exit. Returns the unregister. */
export function registerPreviewExit(fn: () => Promise<void>): () => void {
  exit = fn;
  return () => {
    if (exit === fn) exit = null;
  };
}

/** Run the live preview's Exit (rewind its steps, close it); resolves at once when none is open. */
export async function leaveCustomerPreview(): Promise<void> {
  if (exit) await exit();
}
